export default "__VITE_ASSET__D2roaCLR__"